import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { ModeFormValues } from "src/models/Mode.model";
import Mode from "../Layouts/ModeForm";
import { useAddModeMutation } from "src/services/ModeServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddModeWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: ModeFormValues = {
    modeName: "",
    description: "",
    bookType: "",
    modeCode: "",
  };
  const [addMode] = useAddModeMutation();

  // Validation Schema
  const validationSchema = object().shape({
    modeName: string().required("Please enter mode name"),
    modeCode: string().required("Please enter mode code"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ModeFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ModeFormValues>
  ) => {
    const payload = {
      modeName: values.modeName,
      description: values.description,
      bookType: values.bookType,
      modeCode: values.modeCode,
    };
    addMode(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Mode formikProps={formikProps} onClose={onClose} formType="ADD" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddModeWrapper;
